export type AppEnv = 'dev' | 'test' | 'staging' | 'prod'

export const APP_ENV: AppEnv = (() => {
  const env = process.env.NEXT_PUBLIC_ENVIRONMENT
  if (env === 'test' || env === 'staging' || env === 'dev') return env
  return 'prod'
})()

export const ADMIN_PUBLIC_API_URL = 'https://digen-admin-lyart.vercel.app'

/** templates / models / banners 等是否直连 admin（仅 test / 本地 dev） */
export function shouldUseAdminPublicApi(): boolean {
  return APP_ENV === 'dev' || APP_ENV === 'test'
}

/** Admin 公共接口 query `env`：测试直连 lyart 时固定 test，预发布和线上跟 APP_ENV */
export const ADMIN_API_ENV: AppEnv = shouldUseAdminPublicApi() ? 'test' : APP_ENV

/** Admin 请求是否包含草稿（test 库带草稿，预发布和线上只读已发布） */
export const ADMIN_API_PREVIEW = ADMIN_API_ENV === 'test'

export const IS_TEST_ENV = APP_ENV === 'test'

export const clientId = IS_TEST_ENV
  ? '366069117406-9qe3r5hb5kqnhkd25saliomr8nas2n1s.apps.googleusercontent.com'
  : '892477001862-fpg8qn0s5jnfqmjb5pq9b6hoophrbv8f.apps.googleusercontent.com'

// 透明 1x1 像素 PNG，用于 blur placeholder，避免黑色闪烁
export const fallbackSrc =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
